import React, { Component } from 'react';
import withAppLayout from '../components/appLayout';
import BreadCrumb from '../components/breadcrumb';
import { WhyNfo } from '../components/nfoPage/whyNfo/whyNfo';
import {
  FundHousesSection,
  UsefullToolsSection,
} from '../components/homePageNew';
import { getFundDetailsGraphql, handleAmcPage } from '../utils/index';
import style from '../styles/nfo/nfoListing.scss';
import { Api } from '../api';
import { NFOStates } from '../components/nfoPage/nfoStates/nfoStates';
import AMCFundTableNew from '../components/amc/amcFundTableNew';
import { NFO_HEADER_LIST, NFO_FILTER_LIST } from '../constants';
import FundAvatarNew from '../components/common/fundAvatarNew';
import Loader from '../components/ui/Loader';
import { SECTION_TOOLS } from '../constants/homeConstantsNew';
import { nfoListing } from '../query/nfo';

const api = new Api();

interface State {
  otherAMCList: any;
  nfoData: any;
  selectedStatus: string;
  noResult: boolean;
  listData: any;
}

export class NfoListing extends Component<any, State> {
  constructor(props: any) {
    super(props);
    this.state = {
      otherAMCList: [],
      nfoData: [],
      selectedStatus: 'all',
      noResult: false,
      listData: null,
    };
  }

  public componentDidMount() {
    this.callAmcList();
    getFundDetailsGraphql(nfoListing).then((resp) => {
      if (resp && resp.data) {
        this.setState({
          listData: resp.data,
        });
      }
    });
  }

  private callAmcList() {
    handleAmcPage(api).then((response: any) => {
      let otherAMCRes = response['amcs'];
      otherAMCRes = otherAMCRes.slice(0, 12);
      this.setState({
        otherAMCList: otherAMCRes,
      });
    });
  }

  private getFilters() {
    const { selectedStatus } = this.state;
    return (
      <div className="lil-rounded-xl lil-border-grey-300 lil-shadow-sm lil-border-sm lil-px-6 lil-py-6 lil-mt-5">
        <div>
          <span className="lil-font-semibold lil-text-s-14">Status</span>
        </div>
        <div className="lil-flex lil-flex-wrap">
          {NFO_FILTER_LIST.map((ele) => {
            return (
              <span
                className={`lil-rounded-lg lil-text-s-14 lil-border-sm lil-px-4 lil-my-2 lil-cursor-pointer lil-mr-2 lil-py-2 ${
                  ele.key === selectedStatus
                    ? 'lil-text-blue-350 lil-border-blue-350'
                    : 'lil-text-font-200 lil-border-grey-300 '
                }`}
                onClick={() => {
                  this.setState({ selectedStatus: ele.key });
                }}
              >
                {ele.label}
              </span>
            );
          })}
        </div>
      </div>
    );
  }
  public getMobileFilters() {
    const { selectedStatus } = this.state;
    return (
      <div className="lil-flex lil-flex-wrap">
        {NFO_FILTER_LIST.map((ele) => {
          return (
            <span
              className={`lil-rounded-lg lil-text-s-14 lil-border-sm lil-px-4 lil-my-2 lil-cursor-pointer lil-mr-2 lil-py-2 ${
                ele.key === selectedStatus
                  ? 'lil-text-blue-350 lil-border-blue-350'
                  : 'lil-text-font-200 lil-border-grey-300 '
              }`}
              onClick={() => {
                this.setState({ selectedStatus: ele.key });
              }}
            >
              {ele.label}
            </span>
          );
        })}
      </div>
    );
  }

  public getReturnTable(ele: any) {
    return {
      rowItems: [
        {
          component: (
            <FundAvatarNew
              fundItem={{
                ...ele,
                nfo: true,
                fundMetaData: {
                  slug: ele.slug,
                  parentSlug: ele.parentSlug,
                  isinCode: ele.isinCode,
                },
              }}
              width={12}
              columnWidth={screen.width > 768 ? 350 : 210}
              infoWidth={15}
              hideSubTitle={false}
              source="nfos"
              className="lil-pt-2 sm:lil-pl-2 lil-h-10"
            />
          ),
        },
        {
          className: 'sm:lil-hidden',
          component: (
            <span
              className={
                ele.nfoMetadata.nfoState === 'LIVE'
                  ? `lil-text-s-10 lil-text-white lil-text-bold lil-px-2 lil-py-1 ${style['live-bg-color']}`
                  : ele.nfoMetadata.nfoState === 'CLOSED'
                  ? `lil-text-s-14 lil-text-bold ${style['closed-text-color']}`
                  : `lil-text-s-14 lil-text-bold ${style['upcoming-text-color']}`
              }
            >
              {ele.nfoMetadata.nfoState}
            </span>
          ),
        },
        {
          className: '',
          component: (
            <span className="lil-text-s-14">₹{ele.minInvestment}</span>
          ),
        },
        {
          className: 'sm:lil-hidden',
          component: (
            <span className="lil-text-s-14">{ele.nfoMetadata.openDate}</span>
          ),
        },
        {
          className: 'sm:lil-hidden',
          component: (
            <span className="lil-text-s-14">{ele.nfoMetadata.closeDate}</span>
          ),
        },
      ],
    };
  }

  public getTableItems(data: any) {
    const { selectedStatus } = this.state;
    let allData = [];
    const liveNfos = data.getNfos.liveNfos.map((ele) => {
      return this.getReturnTable(ele);
    });
    const closedNfos = data.getNfos.closedNfos.map((ele) => {
      return this.getReturnTable(ele);
    });
    const upcomingNfos = data.getNfos.upcomingNfos.map((ele) => {
      return this.getReturnTable(ele);
    });
    allData =
      selectedStatus === 'liveNfos'
        ? [...liveNfos]
        : selectedStatus === 'closedNfos'
        ? [...closedNfos]
        : selectedStatus === 'upcomingNfos'
        ? [...upcomingNfos]
        : [...liveNfos, ...closedNfos, ...upcomingNfos];

    return allData;
  }

  public render() {
    const breadCrumbItems = [
      {
        link: '/mf',
        text: 'Home',
      },
      {
        text: 'NFO listing',
      },
    ];
    const { otherAMCList, listData } = this.state;

    return (
      <div>
        <div className="lil-container lil-py-6">
          <div className="lil-mt-4">
            <BreadCrumb
              breadcrumbs={breadCrumbItems}
              linkStyles={style['breadcrumb-link']}
            />
          </div>
          <h1 className="lil-text-s-40 lil-py-6 sm:lil-text-s-24">
            Explore new fund offers (NFO)
          </h1>
          <div className="lil-flex lil-flex-wrap lil-pt-6 lil-pb-12 sm:lil-pt-0">
            <div className="lil-w-1/4 lil-pr-2 sm:lil-hidden">
              <div>
                <span className="lil-font-bold">FILTERS</span>
                <span
                  style={{ float: 'right' }}
                  className={`lil-text-blue-350 lil-text-s-14 lil-font-medium lil-cursor-pointer lil-pr-2`}
                  onClick={() => {
                    this.setState({ selectedStatus: 'all' });
                  }}
                >
                  Reset All
                </span>
              </div>
              {this.getFilters()}
            </div>
            <div className="lg:lil-hidden md:lil-hidden xl:lil-hidden sm:lil-w-full">
              {this.getMobileFilters()}
            </div>
            <div className="lil-w-3/4 lil-pl-0 lil-pt-6 sm:lil-pt-2 sm:lil-w-full">
              {!listData ? (
                <Loader />
              ) : this.getTableItems(listData).length > 0 ? (
                <AMCFundTableNew
                  itemtype="http://schema.org/Table"
                  itemprop="about"
                  title={''}
                  headingData={NFO_HEADER_LIST}
                  bodyData={this.getTableItems(listData)}
                ></AMCFundTableNew>
              ) : (
                <div className="row lil-pt-6">
                  <p className="lil-font-semibold lil-text-s-20 lil-text-center">
                    Uh oh! No results found.
                  </p>
                </div>
              )}
            </div>
          </div>
          <WhyNfo headerClass="lil-text-s-40 sm:lil-text-s-24" />
          <NFOStates />
        </div>
        <FundHousesSection
          otherAMCList={otherAMCList}
          headerClass="lil-text-s-40 sm:lil-text-s-24"
        />
        <UsefullToolsSection
          SECTION_TOOLS={SECTION_TOOLS}
          headerClass="lil-text-s-40 sm:lil-text-s-24"
        />
      </div>
    );
  }
}

export default withAppLayout({ title: 'Nfos' }, NfoListing);



// WEBPACK FOOTER //
// ./pages/nfos.tsx